import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MainApi from "../../../../../../../../services/mainApi.service";
import { TIpmGeneralSettingsForm } from "../IpmGeneralSettingsSchema";
import { IIpmVersionFieldProps } from "./models";

const GENERIC_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApi<ISelectType>(GENERIC_ROUTE);

const translationPath = "page.settings.4uBus.ipm.generalSettings.";

export const IpmVersionField = memo(
  ({ currentIpmVersion }: IIpmVersionFieldProps) => {
    const { t } = useTranslation();

    const [options, setOptions] = useState<ISelectType[]>([]);

    const { setValue } = useFormContext<TIpmGeneralSettingsForm>();

    const { sendRequest } = useFetch(genericService.list);

    const fetchIpmVersions = useCallback(async () => {
      const { data, success } = await sendRequest({ Identifier: "IPMVersion" });
      if (data && success) {
        setOptions(data);
      }
    }, [sendRequest]);

    const getCurrentIpmVersion = useCallback(() => {
      if (!currentIpmVersion) return;
      setValue(
        "ipmVersion",
        options.find((option) => option.name === currentIpmVersion) || null
      );
    }, [currentIpmVersion, options, setValue]);

    useLayoutEffect(() => {
      fetchIpmVersions();
    }, [fetchIpmVersions]);

    useEffect(() => {
      getCurrentIpmVersion();
    }, [getCurrentIpmVersion]);

    return (
      <Grid item xs={12} sm={2}>
        <AutoComplete
          name="ipmVersion"
          label={t(translationPath + "ipm_version")}
          getOptionLabel={(option) => option.name}
          size="small"
          clearIcon={false}
          fullWidth
          autoFocus
          options={options}
        />
      </Grid>
    );
  }
);
